// extracted by mini-css-extract-plugin
export var addButton = "_q0-0";
export var border = "_q0-8";
export var check = "_q0-h";
export var danger = "_q0-6";
export var dropdownContainer = "_q0-1";
export var editModalBody = "_q0-j";
export var footerContainer = "_q0-i";
export var fullWidth = "_q0-a";
export var hide = "_q0-9";
export var icon = "_q0-3";
export var input = "_q0-7";
export var inputFlex = "_q0-b";
export var inputWrapper = "_q0-c";
export var manualFocus = "_q0-5";
export var optionButton = "_q0-4";
export var pillWrapper = "_q0-e";
export var pointer = "_q0-2";
export var showOverflow = "_q0-f";
export var tagsFlex = "_q0-d";
export var xButton = "_q0-g";